import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    // Google renvoie ?code=... sur /auth/callback ; on transmet le code et
    // l'URI de redirection utilisee (le serveur en a besoin pour l'echange).
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    // Anti-CSRF de connexion : le `state` renvoyé par Google doit correspondre
    // à celui qu'on a tiré au sort et rangé avant la redirection. Sinon, un
    // attaquant pourrait faire ouvrir SON flux à la victime et la connecter à
    // son propre compte. On consomme le state (usage unique).
    const attendu = sessionStorage.getItem("oauth_state");
    sessionStorage.removeItem("oauth_state");
    const recu = params.get("state");
    const stateOk = attendu && recu && attendu === recu;
    const sessionId = code && stateOk ? `${code}|${window.location.origin}/auth/callback` : null;
    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-app">
      <Loader2 className="h-8 w-8 animate-spin text-brand-ink" />
    </div>
  );
}
